export type ResultsTab = "deals" | "research";

export interface TabVisibility {
  showDeals: boolean;
  showResearch: boolean;
  showTabChrome: boolean;
  defaultTab: ResultsTab | null;
}

/**
 * Decide which tabs to render and whether to show tab chrome.
 * Deals-only turns must render identically to today — no chrome, deals tab.
 * Research-only renders the research table directly — no chrome.
 * Only when both are present do we show the tab switcher.
 */
export function decideTabVisibility(
  dealCount: number,
  researchCount: number
): TabVisibility {
  const showDeals = dealCount > 0;
  const showResearch = researchCount > 0;
  const bothPresent = showDeals && showResearch;
  return {
    showDeals,
    showResearch,
    showTabChrome: bothPresent,
    defaultTab: showDeals ? "deals" : showResearch ? "research" : null,
  };
}
